import 'css-chunksrc/client/common/filterMenu/projectsElementsTags/tag/styles.scss';export default {
  "tag": "_tag_zw9kk_1",
  "name": "_name_zw9kk_11"
};